import { SidebarActions, TOGGLE_SIDEBAR } from '../actions';

interface ISidebarState {
  isOpen: boolean;
}

export const defaultState: ISidebarState = {
  isOpen: true
};

export const sidebarReducer = (state = defaultState, action: SidebarActions) => {
  switch (action.type) {
    case TOGGLE_SIDEBAR: {
      return {
        ...state,
        isOpen: action.payload
      };
    }
    default: {
      return state;
    }
  }
};
